import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from 'app/main/services/app.service';
import { BaseLanguageLoaderComponent } from '../../pages/base-language-loader.component';

@Component({
	selector: 'backtolist',
	templateUrl: './backtolist.component.html',
	styleUrls: ['./backtolist.component.scss']
})
export class BackToListComponent implements OnInit {

	constructor(public appService: AppService) {}

	ngOnInit(): void {}
}
